module.exports = __webpack_public_path__ + "static/media/stock-barcodes.b0d155ef.svg";